enum MainInvoiceAgreementProvider {
  EINVOICE = 'EINVOICE',
  DIGIPOST = 'DIGIPOST',
}

export default MainInvoiceAgreementProvider;
